import React from "react";
import {Outlet} from "react-router-dom";
import {Box, Colors, Container} from "@bounce/shared/ui";
import MenuLayout from "./MenuLayout";

const ReachLayout = () => (
  <Container row sx={{height: "100vh", alignItems: "stretch", gap: 0, backgroundColor: Colors.tertiary._100}}>
    <MenuLayout />
    <Box sx={{flex: 1, overflow: "auto"}}>
      <Outlet />
    </Box>
  </Container>
);

export default ReachLayout;
